import CreatePasswordContentContainer from "./CreatePasswordContent.container";
import React from "react";

const CreatePasswordContent: React.FC = () => (
  <CreatePasswordContentContainer />
);

export default CreatePasswordContent;
